import React from 'react'
import {translate} from 'react-i18next'
import View from 'components/View'
import Title from 'components/Title'
import LinkWithButton from '../LinkWithButton'
import theme from 'theme'
import PageMessage from 'components/PageMessage'
import Note from 'components/Note'

const EmailVerifiedMessage = ({t, handleClick, loading}) => (
  <View>
    <Title>{t('email-verified.title')}</Title>
    <PageMessage>
      <Note light>{t('email-verified.message')}</Note>
    </PageMessage>
    <LinkWithButton
      to={theme.brand.url}
      text={t('email-verified.redirect-button')}
      onClick={handleClick && handleClick()}
      loading={loading}
    />
  </View>
)

export default translate()(EmailVerifiedMessage)
